export default __webpack_public_path__ + "static/media/add-article-disagreement.26282881.svg";